import { useMemo, FC } from 'react';
import { useTranslation } from 'react-i18next';
import { stringifyUrl, stringify } from 'query-string';
import { getHeapUserId } from '../util/Analytics';

type AppQrCodeProps = {
  width: number;
  height: number;
  children?: never;
};

const GA_PLAY_STORE_REFERRER_QR = {
  referrer: stringify({
    utm_source: 'CWO',
    utm_medium: 'desktop_qr_code',
  }),
};

export const AppQrCode: FC<AppQrCodeProps> = ({ width, height }) => {
  const { t } = useTranslation();
  const heapUserId = getHeapUserId();
  const qrsrc = useMemo(
    () => stringifyUrl({
        url: 'https://chart.googleapis.com/chart',
        query: {
          cht: 'qr',
          chs: `${width}x${height}`,
          chl: stringifyUrl({
            url: `${window.location.origin}/online-ordering/app`,
            query: {
              ...GA_PLAY_STORE_REFERRER_QR,
              heapUserId,
            },
          }),
        },
      }),
    [heapUserId, height, width]
  );

  return <img title={t('appDownload.scan')} alt={t('appDownload.scan')} src={qrsrc} />;
};
